document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.section-features__video-slider-carousel');
  const items = document.querySelectorAll('.section-features__video-slider-carousel-item');
  const dotsContainer = document.querySelector('.section-features__video-slider-dots');
  
  if (!carousel || !items.length) return;
  
  let currentIndex = 1; // Start at second item
  const totalItems = items.length;
  
  // Drag/swipe variables
  let isDragging = false;
  let startX = 0;
  let currentX = 0;
  let initialTransform = 0;
  let dragThreshold = 50; // Minimum distance to trigger slide change
  let animationId = null; // For smooth animation cleanup
  
  // Create dots based on number of slides
  items.forEach((_, index) => {
    const dot = document.createElement('span');
    dot.classList.add('section-features__video-slider-dot');
    if (index === currentIndex) dot.classList.add('active'); // Mark the second dot as active
    dotsContainer.appendChild(dot);
  });
  
  const dots = document.querySelectorAll('.section-features__video-slider-dot');
  
  // Enhanced cleanup function
  function cleanupDragState() {
    isDragging = false;
    startX = 0;
    currentX = 0;
    initialTransform = 0;
    carousel.style.cursor = 'grab';
    carousel.style.transition = ''; // Reset to CSS default
    
    // Cancel any ongoing animation frames
    if (animationId) {
      cancelAnimationFrame(animationId);
      animationId = null;
    }
  }
  
  function updateCarousel(index, forceCleanup = false) {
    // Clean up any ongoing drag state when using dots or programmatic changes
    if (forceCleanup) {
      cleanupDragState();
    }
    
    let margin;
    if(window.innerWidth > 500){
      margin = 40;
    } else {
      margin = 20;
    }
    const itemWidth = items[0].offsetWidth + margin; // margin left + right
    carousel.style.transform = `translateX(calc(50% - ${itemWidth * index + itemWidth / 2}px))`;
    items.forEach(item => item.classList.remove('active'));
    items[index].classList.add('active');
    dots.forEach(dot => dot.classList.remove('active'));
    dots[index].classList.add('active');
  }
  
  function goToSlide(index, fromDot = false) {
    if (index < 0) index = totalItems - 1;
    if (index >= totalItems) index = 0;
    currentIndex = index;
    
    // Force cleanup when coming from dot click
    updateCarousel(currentIndex, fromDot);
  }
  
  // Check if target is a video or video control
  function isVideoElement(target) {
    return target.tagName === 'VIDEO' || 
           target.closest('video') || 
           target.closest('.video-controls') ||
           target.closest('button') ||
           target.closest('a') ||
           target.hasAttribute('controls') ||
           target.classList.contains('video-play-button') ||
           target.classList.contains('video-overlay');
  }
  
  // Get current transform value
  function getCurrentTransform() {
    const style = window.getComputedStyle(carousel);
    const matrix = style.transform;
    if (matrix === 'none') return 0;
    
    const values = matrix.split('(')[1].split(')')[0].split(',');
    return parseFloat(values[4]) || 0;
  }
  
  // Enhanced mouse down handler
  function handleMouseDown(e) {
    // Allow video interactions but prevent drag initiation
    if (isVideoElement(e.target)) {
      return;
    }
    
    // Clean up any previous state
    cleanupDragState();
    
    isDragging = true;
    startX = e.clientX;
    initialTransform = getCurrentTransform();
    carousel.style.cursor = 'grabbing';
    carousel.style.transition = 'none';
    e.preventDefault();
  }
  
  function handleMouseMove(e) {
    if (!isDragging) return;
    
    // Use requestAnimationFrame for smoother movement
    if (animationId) {
      cancelAnimationFrame(animationId);
    }
    
    animationId = requestAnimationFrame(() => {
      currentX = e.clientX;
      const diffX = currentX - startX;
      const newTransform = initialTransform + diffX;
      
      carousel.style.transform = `translateX(${newTransform}px)`;
    });
  }
  
  function handleMouseUp(e) {
    if (!isDragging) return;
    
    const diffX = currentX - startX;
    
    // Determine if we should change slides
    if (Math.abs(diffX) > dragThreshold) {
      if (diffX > 0) {
        // Dragged right, go to previous slide
        goToSlide(currentIndex - 1);
      } else {
        // Dragged left, go to next slide
        goToSlide(currentIndex + 1);
      }
    } else {
      // Snap back to current slide
      updateCarousel(currentIndex);
    }
    
    // Clean up after handling the drag end
    cleanupDragState();
  }
  
  // Enhanced touch handlers
  function handleTouchStart(e) {
    // Clean up any previous state
    cleanupDragState();
    
    isDragging = true;
    startX = e.touches[0].clientX;
    initialTransform = getCurrentTransform();
    carousel.style.transition = 'none';
  }
  
  function handleTouchMove(e) {
    if (!isDragging) return;
    
    // Use requestAnimationFrame for smoother movement
    if (animationId) {
      cancelAnimationFrame(animationId);
    }
    
    animationId = requestAnimationFrame(() => {
      currentX = e.touches[0].clientX;
      const diffX = currentX - startX;
      const newTransform = initialTransform + diffX;
      
      carousel.style.transform = `translateX(${newTransform}px)`;
    });
    
    e.preventDefault(); // Prevent scrolling
  }
  
  function handleTouchEnd(e) {
    if (!isDragging) return;
    
    const diffX = currentX - startX;
    
    // Determine if we should change slides
    if (Math.abs(diffX) > dragThreshold) {
      if (diffX > 0) {
        // Swiped right, go to previous slide
        goToSlide(currentIndex - 1);
      } else {
        // Swiped left, go to next slide
        goToSlide(currentIndex + 1);
      }
    } else {
      // Snap back to current slide
      updateCarousel(currentIndex);
    }
    
    // Clean up after handling the touch end
    cleanupDragState();
  }
  
  // Mouse leave handler to clean up if mouse leaves carousel while dragging
  function handleMouseLeave(e) {
    if (isDragging) {
      // Snap back to current slide and clean up
      updateCarousel(currentIndex);
      cleanupDragState();
    }
  }
  
  // Add mouse event listeners (desktop only)
  carousel.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
  carousel.addEventListener('mouseleave', handleMouseLeave);
  
  // Add touch event listeners (mobile)
  carousel.addEventListener('touchstart', handleTouchStart, { passive: false });
  carousel.addEventListener('touchmove', handleTouchMove, { passive: false });
  carousel.addEventListener('touchend', handleTouchEnd);
  
  // Enhanced context menu prevention
  carousel.addEventListener('contextmenu', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
  
  // Set cursor styles with video exception (desktop only)
  carousel.style.cursor = 'grab';
  
  // Update cursor on hover - show pointer over videos, grab elsewhere
  carousel.addEventListener('mouseover', (e) => {
    if (isVideoElement(e.target)) {
      e.target.style.cursor = 'pointer';
      // Also set cursor on video container if it exists
      const videoContainer = e.target.closest('.video-container') || e.target.closest('.video-wrapper');
      if (videoContainer) {
        videoContainer.style.cursor = 'pointer';
      }
    } else if (!isDragging) {
      carousel.style.cursor = 'grab';
    }
  });
  
  carousel.addEventListener('mouseout', (e) => {
    if (isVideoElement(e.target)) {
      e.target.style.cursor = '';
      // Reset cursor on video container
      const videoContainer = e.target.closest('.video-container') || e.target.closest('.video-wrapper');
      if (videoContainer) {
        videoContainer.style.cursor = '';
      }
    }
    if (!isDragging) {
      carousel.style.cursor = 'grab';
    }
  });

  // Handle video clicks specifically (desktop)
  carousel.addEventListener('click', (e) => {
    if (isVideoElement(e.target)) {
      e.stopPropagation();
      // Allow the video click to bubble up naturally for play/pause
      return true;
    }
  });
  
  // Enhanced dot click handlers with cleanup
  dots.forEach((dot, i) => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Force cleanup any ongoing drag state and go to slide
      goToSlide(i, true); // true indicates this is from a dot click
    });
  });
  
  // Enhanced resize handler
  window.addEventListener('resize', () => {
    // Clean up any drag state on resize
    cleanupDragState();
    updateCarousel(currentIndex);
  });
  
  // Enhanced visibility change handler (when tab becomes visible/hidden)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && isDragging) {
      // Clean up if page becomes hidden while dragging
      updateCarousel(currentIndex);
      cleanupDragState();
    }
  });
  
  // Initialize
  updateCarousel(currentIndex);
});